import validationMessages from "vee-validate/dist/locale/nb_NO";
//citrix.no
export default {
    privacyLinkLabel: "personvernerklæring",
    privacyLink: '/no-no/about/legal/privacy/',
    privacyText: "Citrix vil behandle opplysningene dine i henhold til vår",
    resetText: "Dersom skjemaet allerede er fylt ut av en annen bruker, vennligst",
    resetText2: "for å tilbakestille.",
    resetLinkText: "klikk her",
    yes: "Ja",
    no: "Nei",
    submitBtn: {
        "Submit" : "Send inn",
        "Get the eBook" : "Få e-boken",
        "Watch demo" : "Watch demo",
        "Get the kit" : "Få pakken",
        "Request a demo": "Be om en demo",
        "Request a call": "Bli kontaktet"
    },
    apjPrivacy:{
        title: "Hvordan vi bruker din personlige informasjon",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") bruker og lagrer din personlige informasjon i henhold til gjeldende lover og bestemmelser om datavern samt",
        linkText: "Citrix' personvernerklæring",
        part2: "og i situasjoner hvor tilgang er fullstendig begrenset. Citrix bruker den personlige informasjonen kun som beskrevet i personvernerklæringen og ikke til noen andre formål. I samsvar med personvernerklæringen kan Citrix overlate behandlingen av personlig informasjon til innenlandske eller utenlandske virksomheter, dele personlig informasjon med andre Citrix-kontorer eller datterselskaper over hele verden, eller sende personlig informasjon til innenlandske eller utenlandske tredjeparter. Når du sender personlig informasjon til Citrix, samtykker du i innsamlingen og behandlingen av informasjonen som beskrevet i selskapets Citrix personvernerklæring.",
        privacyAccept: "Jeg har lest og godtar innholdet samt Citrix' personvernerklæring"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Bedrift"
        },
        "department": {
            label: "Avdeling",
            options: [
                { value: "Application Management", text: "Applikasjonsforvaltning" },
                { value: "Consulting Services", text: "Konsulenttjenester" },
                { value: "Education / Training", text: "Utdanning/opplæring" },
                { value: "Engineering", text: "Teknisk ekspertise" },
                { value: "Executive Office / Administration", text: "Administrasjon" },
                { value: "Finance / Accounting", text: "Finans/regnskapsføring" },
                { value: "Human Resources", text: "HR" },
                { value: "Information Technology - Systems", text: "IT-systemer" },
                { value: "Legal", text: "Juridisk" },
                { value: "Marketing / PR", text: "Markedsføring/PR" },
                { value: "Networking", text: "Nettverksteknologi" },
                { value: "Operations / Manufacturing", text: "Drift/utvikling" },
                { value: "Pre-Sales / Technical Support", text: "Før-salg/teknisk støtte" },
                { value: "Project Management", text: "Prosjektledelse" },
                { value: "Purchasing", text: "Innkjøp" },
                { value: "Sales / Bus-Corp Development", text: "Salg/bedriftsutvikling" },
                { value: "Security", text: "Sikkerhet" },
                { value: "Web / Online / E-Business", text: "Internett / elektronisk forretningsdrift" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Bransje",
            options: [
                { value: "Mining - All", text: "All gruvedrift" },
                { value: "Business/Personal Services", text: "Bedrifts- / personlige tjenester" },
                { value: "Business Consulting", text: "Bedriftsrådgivning" },
                { value: "Construction and Design", text: "Bygg og design" },
                { value: "Retail/Wholesale", text: "Detaljhandel" },
                { value: "E-Commerce", text: "E-handel" },
                { value: "Real Estate", text: "Eiendom" },
                { value: "Pharmaceuticals", text: "Farmasi" },
                { value: "Finance", text: "Finans" },
                { value: "Consumer Packaged Goods", text: "Forbruksvarer" },
                { value: "Publishing/Printing", text: "Forlag/trykk" },
                { value: "Insurance", text: "Forsikring" },
                { value: "Government/State-Province", text: "Fylkeskommunen" },
                { value: "Health Care", text: "Helsevesenet" },
                { value: "Household Services", text: "Husholdningstjenester" },
                { value: "Legal", text: "Juridisk" },
                { value: "Chemical Manufacturing", text: "Kjemisk industri" },
                { value: "Government/Local", text: "Kommunen" },
                { value: "Conglomerate", text: "Konglomerat" },
                { value: "Art & Membership", text: "Kunst og medlemskap" },
                { value: "Agriculture", text: "Landbruk" },
                { value: "Oil and Gas", text: "Olje og gass" },
                { value: "Personnel Services", text: "Personaltjenester" },
                { value: "Manufacturing", text: "Produksjon" },
                { value: "Professional Services", text: "Profesjonelle tjenester" },
                { value: "Hospitality", text: "Servicebransjen" },
                { value: "Service Provider", text: "Spesialisert partner" },
                { value: "Government/National-Federal", text: "Staten" },
                { value: "Engineering", text: "Teknisk ekspertise" },
                { value: "Technology", text: "Teknologi" },
                { value: "Telecommunication", text: "Telekommunikasjon" },
                { value: "Transportation", text: "Transport" },
                { value: "Entertainment", text: "Underholdning" },
                { value: "Education", text: "Utdanning" },
                { value: "Charitable/Non-Profit", text: "Veldedig organisasjon" },
                { value: "Utilities", text: "Verktøy" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Bedriftsstørrelse",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Bedriftsstørrelse",
            options: [
                { value: "5,001 +", text: "5 001 +" },
                { value: "1,001 to 5,000", text: "1 001 til 5 000" },
                { value: "501 to 1,000", text: "501 til 1 000" },
                { value: "251 to 500", text: "251 til 500" },
                { value: "1 to 250", text: "1 til 250" }
            ]
        },
        "Address2": {
            label: "Adresselinje 2"
        },
        "Address3": {
            label: "Adresselinje 3"
        },
        "city": {
            label: "By"
        },
        "country": {
            label: "Land"
        },
        "email": {
            label: "Jobb e-post"
        },
        "firstName": {
            label: "Fornavn"
        },
        "lastName": {
            label: "Etternavn"
        },
        "phone": {
            label: "Telefonnummer"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Postnummer"
        },
        "salutation": {
            label: "Tiltale",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Stat/fylke\n"
        },
        "address": {
            label: "Adresse"
        },
        "Job_Title__c": {
            label: "Jobbtittel",
            options: [
                { value: "Analyst", text: "Analytiker" },
                { value: "Architect", text: "Arkitekt" },
                { value: "Assistant", text: "Assistent" },
                { value: "Business Manager", text: "Bedriftsleder" },
                { value: "Director", text: "Direktør" },
                { value: "Owner / Partner", text: "Eier/partner" },
                { value: "IT Manager", text: "IT-ansvarlig" },
                { value: "Consultant", text: "Konsulent" },
                { value: "Network Administrator / Engineer", text: "Nettverksadministrator/ingeniør" },
                { value: "Student", text: "Student" },
                { value: "System Administrator", text: "Systemadministrator" },
                { value: "C-Level / President / VP", text: "Toppledelse / Adm. dir. / Viseadm. dir." },
                { value: "Developer / Programmer", text: "Utvikler/programmerer" }
            ]
        },
        "Project_Budget__c": {
            label: "Budsjett for prosjektet",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nei" },
                { value: "Unknown", text: "Ukjent" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "Trykk CTRL for å velge mer enn ett alternativ (maks. 5 alternativer)"
        },
        "Purchase_Timeframe__c": {
            label: "Tidsramme for kjøp",
            options: [
                { value: "3 months or less", text: "Om 3 måneder eller mindre" },
                { value: "4 to 6 months", text: "Om 4 til 6 måneder" },
                { value: "7 months or more", text: "Om 7 måneder eller mer" },
                { value: "No time frame", text: "Ingen tidsramme" },
                { value: "Unknown", text: "Usikker" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Kan vi sende deg e-poster?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nei" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nei" }
            ]
        },
        "OK_to_Call__c": {
            label: "Kan vi ringe deg?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nei" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Jeg vil at en selger skal kontakte meg"
        },
        "Comments_6__c":{
            label: "Kommentar"
        }
    },
    validation: validationMessages
}